// removed by extract-text-webpack-plugin
module.exports = {"buttonRounded":"ftx8pVm951TOtx-QyCWkF","left":"_2HDkwplfD1F9k3WhCcnVcE","right":"_1B_-Bp6_YPieg7Vtdz5qMO","filled":"_2q7D0SFbKXdES0W9Ld89fi","warning":"_9UJ_qBFJh_Ks7B215199r"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/components/actions/ButtonRounded.css
// module id = 295
// module chunks = 0